import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UserTypes } from 'src/app/models/userTypes';
import { USER_TYPE } from 'src/app/models/constants';
import { NgIf, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    imports: [NgIf, NgClass, MatIcon]
})
export class HeaderComponent implements OnInit {

  @Input() isStudent: boolean = false;

  username: string = "";
  currentUrl: string = "";
  role: UserTypes = UserTypes.EMA;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    let decodedJwt = this.authService.getDecodedJWT(); 
    this.username = decodedJwt?.username;
    this.router.events.subscribe((res:any) => { 
      this.currentUrl = this.router.url;
    });
    this.role = sessionStorage.getItem(USER_TYPE) as UserTypes;
    console.log("user role: ", this.role);

    // if (this.route.snapshot.params['role'] == 'sam') {
    //   this.role =  UserTypes.SAM;
    //   console.log("It is a SAM user")
    // }
  } 

  showDashboardMenu(){
    return !this.isStudent && this.role !== UserTypes.SAM;
  }

  navigate(url: string) {
    // check if url has id ('', URL, ID)
    console.log(this.router.url.split('/'))
    if(this.router.url.split('/').length == 3){
      const studentId = this.router.url.split('/')[2].split('_')[0];
      this.router.navigate([url, studentId]);
    } else {
      this.router.navigateByUrl(url);
    }
    
  }

}
